import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface BlightCardLinkProps {
	blightCard: string
}

export function BlightCardLink(props: BlightCardLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('blightCards', props.blightCard)
		}}>
			{props.blightCard}
		</a>
	)
}
